export default __webpack_public_path__ + "static/media/logo.084b626a.png";